import config from 'src/config'
import helpers from 'src/helpers'

function load(component) {
  return () => import(`src/${component}.vue`)
}

let path = name => helpers.makeStringConcatenation('modules.settings', name)

const MODULE_PATH = '/settings/'

export default [
  {
    path: MODULE_PATH,
    component: load('containers/Full'),
    name: 'Settings',
    meta: {
      title: 'settings.sideMenu.title',
      menuItem: true,
      sorting: config.sidebar.menu.sorting.modules.settings,
      icon: 'settings',
      isForceInclude: true,
    },
    children: [
      {
        path: MODULE_PATH + 'modules',
        component: load('application/settings/components/EmptyComponent'),
        redirect: MODULE_PATH + 'modules/setup',
        meta: {
          title: 'general.module_setup.text',
          icon: 'beenhere',
          menuItem: true,
          sorting: 5000,
          isForceInclude: true,
        },
        children: [
          {
            path: MODULE_PATH + 'modules/setup',
            component: load('application/settings/components/modules/moduleSetupArea'),
            name: 'Module Setup',
            meta: {
              title: 'general.module_setup.text',
              icon: 'beenhere',
              menuItem: true,
              sorting: 5000,
              isForceInclude: true,
            },
          },
          {
            path: MODULE_PATH + 'modules/create',
            component: load('application/settings/components/modules/forms/createUpdateModuleForm'),
            name: 'Create Module',
            meta: {
              title: 'general.create_module.text',
              icon: 'add',
              menuItem: false,
              sorting: 5000,
              isForceInclude: true,
            },
          },
          {
            path: MODULE_PATH + 'modules/[:moduleId]/update',
            component: load('application/settings/components/modules/forms/createUpdateModuleForm'),
            name: 'Update Module',
            meta: {
              title: 'general.update_module.text',
              icon: 'create',
              menuItem: false,
              sorting: 5000,
              isForceInclude: true,
            },
            props: true,
          },
        ],
      },
      {
        path: MODULE_PATH + 'role/groups/',
        component: load('application/settings/components/security/RoleGroup'),
        redirect: MODULE_PATH + 'role/groups/setup',
        name: 'Role Groups',
        meta: {
          title: 'settings.sideMenu.roleGroupsSetup.title',
          icon: 'accessibility',
          menuItem: true,
          sorting: 5000,
          isForceInclude: true,
        },
        children: [
          {
            path: 'setup',
            component: load('application/settings/components/security/roleGroupsSetupArea'),
            name: 'Role Groups List',
            meta: {
              title: 'Role Group List',
              icon: 'accessibility',
              menuItem: true,
              sorting: 5000,
              isForceInclude: true,
            },
          },
          {
            path: 'add',
            component: load('application/settings/components/security/forms/createUpdateRoleGroupForm'),
            name: 'Role Group Create',
            meta: {
              isForceInclude: true,
              title: 'Role Group Create',
              icon: 'accessibility',
              menuItem: false,
              sorting: 5000,
            },
          },
          {
            path: '[:roleGroupID]/update',
            component: load('application/settings/components/security/forms/createUpdateRoleGroupForm'),
            name: 'Role Group Update',
            props: true,
            meta: {
              isForceInclude: true,
              title: 'settings.sideMenu.rolesGroupUpdate.title',
              icon: 'accessibility',
              menuItem: false,
              sorting: 5000,
            },
          },
        ],
      },
      {
        path: MODULE_PATH + 'roles/setup',
        component: load('application/settings/components/security/rolesSetupArea'),
        name: 'Roles Setup',
        meta: {
          isForceInclude: true,
          title: 'settings.sideMenu.rolesSetup.title',
          icon: 'accessibility',
          menuItem: true,
          sorting: 5000,
        },
        children: [],
      },
      {
        path: MODULE_PATH + 'roles/role/builder',
        component: load('application/settings/components/security/builder/roleBuilderArea'),
        name: 'Role Builder',
        props: true,
        meta: {
          isForceInclude: true,
          title: 'settings.sideMenu.rolesBuilder.title',
          icon: 'accessibility',
          menuItem: false,
          sorting: 5000,
        },
      },
      {
        path: MODULE_PATH + 'roles/role/[:roleID]/update',
        component: load('application/settings/components/security/builder/roleBuilderArea'),
        name: 'Role Update',
        props: true,
        meta: {
          isForceInclude: true,
          title: 'settings.sideMenu.rolesBuilder.title',
          icon: 'accessibility',
          menuItem: false,
          sorting: 5000,
        },
      },
      {
        path: MODULE_PATH + 'user/setup',
        component: load('application/settings/components/EmptyComponent'),
        redirect: MODULE_PATH + 'user/setup',
        meta: {
          isForceInclude: true,
          title: 'settings.sideMenu.userSetup.title',
          icon: 'accessibility',
          menuItem: true,
          sorting: 5000,
        },
        children: [
          {
            path: MODULE_PATH + 'user/setup',
            component: load('application/settings/components/security/userSetupArea'),
            name: 'User Setup',
            props: true,
            meta: {
              isForceInclude: true,
              title: 'settings.sideMenu.userSetup.title',
              icon: 'accessibility',
              menuItem: true,
              sorting: 5000,
            },
          },
          {
            path: MODULE_PATH + 'user/setup/add',
            component: load('application/settings/components/security/users/User'),
            name: 'Add User',
            meta: {
              isForceInclude: true,
              title: 'settings.sideMenu.userSetup.title',
              icon: 'accessibility',
              menuItem: false,
              sorting: 5000,
            },
          },
          {
            path: MODULE_PATH + 'user/setup/[:userID]/update',
            component: load('application/settings/components/security/users/User'),
            name: 'Update User',
            props: true,
            meta: {
              isForceInclude: true,
              title: 'settings.sideMenu.userSetup.title',
              icon: 'accessibility',
              menuItem: false,
              sorting: 5000,
            },
          },
        ],
      },
      {
        path: MODULE_PATH + 'master/setup',
        component: load('application/settings/components/master/Masters'),
        name: 'Master',
        redirect: MODULE_PATH + 'master/setup/list',
        meta: {
          isForceInclude: true,
          title: 'masters.sideMenu.masters.title',
          menuItem: false,
          sorting: 5000,
        },
        children: [
          {
            path: MODULE_PATH + 'master/setup/list',
            component: load('application/settings/components/master/MasterList'),
            name: 'Masters List',
            meta: {
              isForceInclude: true,
              title: 'general.master_list.text',
              icon: 'developer board',
              menuItem: false,
              sorting: 5000,
            },
          },
          {
            path: MODULE_PATH + 'master/setup/create',
            component: load('application/settings/components/master/forms/createMasterForm'),
            name: 'Create Master',
            meta: {
              isForceInclude: true,
              title: 'general.create_master.text',
              icon: 'add',
              menuItem: false,
              sorting: 5000,
            },
          },
          {
            path: MODULE_PATH + 'master/setup/[:masterId]/update',
            component: load('application/settings/components/master/forms/updateMasterForm'),
            name: 'Update Master',
            props: true,
            meta: {
              isForceInclude: true,
              title: 'general.update_master.text',
              icon: 'create',
              menuItem: false,
              sorting: 5000,
            },
          },
        ],
      },
      {
        path: MODULE_PATH + 'master/setup/data',
        component: load('application/settings/components/master/MastersData'),
        name: 'Master Data',
        redirect: MODULE_PATH + '/master/setup/data/list',
        meta: {
          isForceInclude: true,
          title: 'Master Data Setup',
          menuItem: false,
          sorting: 5000,
        },
        children: [
          {
            path: 'list',
            component: load('application/settings/components/master/MasterDataList'),
            name: 'Masters Data List',
            props: true,
            meta: {
              isForceInclude: true,
              title: 'Masters Data List',
              icon: 'memory',
              menuItem: false,
              sorting: 5000,
            },
          },
          {
            path: 'create',
            component: load('application/settings/components/master/forms/createMasterDataForm'),
            name: 'Create Master Data',
            meta: {
              isForceInclude: true,
              title: 'Create Master Data',
              icon: 'add',
              menuItem: false,
              sorting: 5000,
            },
          },
          {
            path: '[:masterDataId]/update',
            component: load('application/settings/components/master/forms/updateMasterDataForm'),
            name: 'Update Master Data',
            props: true,
            meta: {
              isForceInclude: true,
              title: 'Update Master Data',
              icon: 'create',
              menuItem: false,
              sorting: 5000,
            },
          },
        ],
      },
      {
        path: MODULE_PATH + 'zone/list',
        component: load('application/settings/components/zone/zoneList'),
        name: 'Zone List',
        meta: {
          isForceInclude: true,
          title: 'Setting.Zone.Route.ZoneList',
          icon: 'attach_money',
          menuItem: true,
          sorting: 5000,
        },
      },
      {
        path: MODULE_PATH + 'zone/create',
        component: load('application/settings/components/zone/forms/createUpdateZoneForm'),
        name: 'New Zone',
        meta: {
          isForceInclude: true,
          title: 'Setting.Zone.Route.ZoneNew',
          icon: 'attach_money',
          menuItem: false,
          sorting: 5000,
        },
      },
      {
        path: MODULE_PATH + 'zone/[:zoneId]/update',
        component: load('application/settings/components/zone/forms/createUpdateZoneForm'),
        name: 'Update Zone',
        props: true,
        meta: {
          isForceInclude: true,
          title: 'Setting.Zone.Route.ZoneUpdate',
          icon: 'attach_money',
          menuItem: false,
          sorting: 5000,
        },
      },
      {
        path: MODULE_PATH + 'tax/list',
        component: load('application/settings/components/tax/taxList'),
        name: 'Tax List',
        meta: {
          isForceInclude: true,
          title: 'Setting.Tax.Route.TaxList',
          icon: 'attach_money',
          menuItem: true,
          sorting: 5000,
        },
      },
      {
        path: MODULE_PATH + 'tax/create',
        component: load('application/settings/components/tax/forms/createUpdateTaxForm'),
        name: 'New Tax',
        meta: {
          isForceInclude: true,
          title: 'Setting.Tax.Route.TaxNew',
          icon: 'attach_money',
          menuItem: false,
          sorting: 5000,
        },
      },
      {
        path: MODULE_PATH + 'tax/[:taxId]/update',
        component: load('application/settings/components/tax/forms/createUpdateTaxForm'),
        name: 'Update Tax',
        props: true,
        meta: {
          isForceInclude: true,
          title: 'Setting.Tax.Route.TaxUpdate',
          icon: 'attach_money',
          menuItem: false,
          sorting: 5000,
        },
      },
      {
        path: MODULE_PATH + 'delivery/charge/list',
        component: load('application/settings/components/delivery-charge/deliveryChargeList'),
        name: 'Delivery Charge List',
        meta: {
          isForceInclude: true,
          title: 'Setting.DeliveryCharge.Route.DeliveryChargeList',
          icon: 'attach_money',
          menuItem: true,
          sorting: 5000,
        },
      },
      {
        path: MODULE_PATH + 'delivery/charge/create',
        component: load('application/settings/components/delivery-charge/forms/createUpdateDeliveryChargeForm'),
        name: 'New Delivery Charge',
        meta: {
          isForceInclude: true,
          title: 'Setting.DeliveryCharge.Route.DeliveryChargeNew',
          icon: 'attach_money',
          menuItem: false,
          sorting: 5000,
        },
      },
      {
        path: MODULE_PATH + 'delivery/charge/[:deliveryChargeId]/update',
        component: load('application/settings/components/delivery-charge/forms/createUpdateDeliveryChargeForm'),
        name: 'Update Delivery Charge',
        props: true,
        meta: {
          isForceInclude: true,
          title: 'Setting.DeliveryCharge.Route.DeliveryChargeUpdate',
          icon: 'attach_money',
          menuItem: false,
          sorting: 5000,
        },
      },
      {
        path: MODULE_PATH + 'workflow/setup',
        component: load('application/settings/components/workflow/workflowSetup'),
        name: 'Workflow Setup',
        meta: {
          isForceInclude: true,
          title: 'Workflow Setup',
          icon: 'beenhere',
          menuItem: false,
          sorting: 5000,
        },
      },
      {
        path: MODULE_PATH + 'reports',
        component: load('application/settings/components/reports/Reports'),
        name: 'Report Config',
        redirect: MODULE_PATH + 'reports/list',
        meta: {
          isForceInclude: true,
          title: 'General.ReportsConfigSetup.Menu.Title',
          icon: 'beenhere',
          menuItem: true,
          sorting: 5000,
        },
        children: [
          {
            path: 'list',
            component: load('application/settings/components/reports/reportsConfigList'),
            name: 'Report Config List',
            meta: {
              isForceInclude: true,
              title: 'General.List.Menu.Title',
              icon: 'beenhere',
              menuItem: false,
              sorting: 5000,
            },
          },
          {
            path: 'create',
            component: load('application/settings/components/reports/forms/createUpdateReportConfigForm'),
            name: 'Report Config Create',
            meta: {
              isForceInclude: true,
              title: 'General.ReportsConfigCreate.Menu.Title',
              icon: 'beenhere',
              menuItem: false,
              sorting: 5000,
            },
          },
          {
            path: '[:configID]/update',
            component: load('application/settings/components/reports/forms/createUpdateReportConfigForm'),
            name: 'Report Config Update',
            props: true,
            meta: {
              isForceInclude: true,
              title: 'General.ReportsConfigUpdate.Menu.Title',
              icon: 'beenhere',
              menuItem: false,
              sorting: 5000,
            },
          },
        ],
      },
      {
        path: MODULE_PATH + 'subscription/setup/member',
        name: 'Member Subscription Setup List',
        component: load('application/settings/components/subscriptions/Subscription'),
        redirect: MODULE_PATH + 'subscription/setup/member/builder',
        meta: {
          isForceInclude: true,
          title: 'General.MemberSubscriptionSetup.Menu.Title',
          icon: 'beenhere',
          menuItem: true,
          sorting: 5000,
        },
        children: [
          {
            path: 'list',
            component: load('application/settings/components/subscriptions/subscriptionPlanList'),
            name: 'Member Subscription Plan List',
            meta: {
              isForceInclude: true,
              title: 'General.MemberSubscriptionPlanListing.Menu.Title',
              icon: 'beenhere',
              menuItem: true,
              sorting: 5000,
            },
          },
          {
            path: 'create',
            component: load('application/settings/components/subscriptions/forms/createUpdateSubscriptionRoleForm'),
            name: 'Subscription Plan Create',
            meta: {
              isForceInclude: true,
              title: 'General.MemberSubscriptionPlanCreateUpdate.Menu.Title',
              translationParam: { type: 'create' },
              icon: 'beenhere',
              menuItem: true,
              sorting: 5000,
            },
          },
          {
            path: '[:planID]/update',
            component: load('application/settings/components/subscriptions/forms/createUpdateSubscriptionRoleForm'),
            name: 'Subscription Plan Update',
            props: true,
            meta: {
              isForceInclude: true,
              title: 'General.MemberSubscriptionPlanCreateUpdate.Menu.Title',
              translationParam: { type: 'update' },
              icon: 'beenhere',
              menuItem: true,
              sorting: 5000,
            },
          },
          {
            path: 'builder',
            component: load('application/settings/components/subscriptions/Builder'),
            name: 'Subscription Plan Builder',
            props: true,
            meta: {
              isForceInclude: true,
              title: 'General.MemberSubscriptionPlanBuilder.Menu.Title',
              translationParam: { type: 'update' },
              icon: 'beenhere',
              menuItem: true,
              sorting: 5000,
            },
          },
        ],
      },
      {
        path: MODULE_PATH + 'department',
        modulePath: '/department',
        component: load('application/settings/components/EmptyComponent'),
        redirect: MODULE_PATH + 'department/setup',
        meta: {
          isForceInclude: true,
          title: path('department.departmentSetup.title'),
          menuItem: config.toggles.modules.settingsDepartment,
          sorting: 5000,
        },
        children: [
          {
            path: MODULE_PATH + 'department/setup',
            component: load('application/settings/components/departments/DepartmentList'),
            name: 'Department Setup List',
            meta: {
              isForceInclude: true,
              title: path('department.departmentList.title'),
              menuItem: true,
              sorting: 5000,
            },
          },
          {
            path: MODULE_PATH + 'department/create',
            component: load('application/settings/components/departments/CreateUpdateDepartmentArea'),
            name: 'Create Department',
            meta: {
              isForceInclude: true,
              title: path('department.createDepartment.title'),
              menuItem: false,
              sorting: 5000,
            },
          },
          {
            path: MODULE_PATH + 'department/[:id]/update',
            component: load('application/settings/components/departments/CreateUpdateDepartmentArea'),
            name: 'Update Department',
            meta: {
              isForceInclude: true,
              title: path('department.updateDepartment.title'),
              menuItem: false,
              sorting: 5000,
            },
            props: true,
          },
        ],
      },
      {
        path: MODULE_PATH + 'currency-conversion/list',
        component: load('application/settings/components/currency-conversion/CurrencyConversionList'),
        name: 'Currency Conversion List',
        meta: {
          isForceInclude: true,
          title: 'Setting.CurrencyConversion.Route.CurrencyConversionList',
          icon: 'attach_money',
          menuItem: true,
          sorting: 5000,
        },
      },
      {
        path: MODULE_PATH + 'currency-conversion/create',
        component: load('application/settings/components/currency-conversion/CreateUpdateCurrencyConversionArea'),
        name: 'New Currency Conversion',
        meta: {
          isForceInclude: true,
          title: 'Setting.CurrencyConversion.Route.CurrencyConversionNew',
          icon: 'attach_money',
          menuItem: false,
          sorting: 5000,
        },
      },
      {
        path: MODULE_PATH + 'withholding-tax',
        component: load('application/settings/components/withholding-tax/WithholdingTaxCreateUpdateArea'),
        name: 'Update Withholding Tax',
        meta: {
          isForceInclude: true,
          title: path('withholdingTaxSetup.title'),
          icon: 'attach_money',
          menuItem: true,
          sorting: 5000,
        },
      },
    ],
  },
]
